import useSWR from 'swr';
import graphqlApi from '../api/graphqlApi';
import { createShopifyProductQuery } from './queries/shopifyProductByHandle';
import { Product } from '../../models/Product';

const useShopifyProductSWR = (handle: string) => {
    const fetchAllMenuItem = (query): Promise<Product> => {
        return graphqlApi
            .post(query)
            .then((res) => {
                return res.productByHandle;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        createShopifyProductQuery(handle),
        fetchAllMenuItem,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        product: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useShopifyProductSWR;
